import { Stack, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import PagesContainer from "../../../components/UI/PagesContainer";
import useFetch from "../../../hooks/useFetch";
import {
  getTasySchedMenu,
  ITasySchedMenu,
} from "../../../services/tasySchedMenu.service";

const ScheduleMenuMessage = () => {
  const { id = "" } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();
  const [fetchedMessage, setFetchedMessage] = useState<string | null>(null);
  const initialMessage = (state as { customMessage?: string | null } | null)
    ?.customMessage;
  const { sendRequest, loading } = useFetch<string, ITasySchedMenu>(
    getTasySchedMenu,
  );

  const customMessage = useMemo(
    () => initialMessage ?? fetchedMessage,
    [fetchedMessage, initialMessage],
  );

  useEffect(() => {
    if (initialMessage || !id) return;

    const fetchMenu = async () => {
      const { data, success } = await sendRequest(id);

      if (success && data) {
        if (!data.customMessage && data.ticketAutomationReceivedRule?.id) {
          navigate(`/schedule-new/menuFlow/${data.id}`, { replace: true });
          return;
        }

        setFetchedMessage(data.customMessage || null);
      }
    };

    fetchMenu();
  }, [id, initialMessage, navigate, sendRequest]);

  return (
    <PagesContainer redirectTo="/schedule-new/menus" loading={loading}>
      <Stack
        sx={{
          minHeight: "100%",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          px: 2,
        }}
      >
        {!!customMessage && (
          <Typography
            component="div"
            variant="h6"
            fontWeight={500}
            dangerouslySetInnerHTML={{ __html: customMessage }}
          />
        )}
      </Stack>
    </PagesContainer>
  );
};

export default ScheduleMenuMessage;
